<ngx-spinner type="ball-atom"></ngx-spinner>
<div class="component-container">
  <div class="component-header">
    <h2>Large Shareholders List</h2>
    <div class="button-group">
      <button mat-raised-button color="primary" (click)="onLargeShareholderCorrected()" *ngIf="rightItem && matchedItems && matchedItems.length > 0">
        <mat-icon>assignment_turned_in</mat-icon>
        Correct
      </button>
      <button mat-raised-button color="primary" (click)="toggleSearch()">
        <mat-icon>search</mat-icon>
        @if (isSearchVisible) { Close search } @else { Search @if (getAppliedFiltersCount() > 0) { ({{ getAppliedFiltersCount() }}) } }
      </button>
      <button mat-raised-button color="primary" (click)="onExportToCsv()">
        <mat-icon>insert_chart_outlined</mat-icon>
        CSV Export
      </button>
    </div>
  </div>
  <app-large-shareholder-search-box
    [isSearchVisible]="isSearchVisible"
    [initialFilter]="currentSearchFilter"
    (largeShareholderSearchFilter)="onLargeShareholderSearchFilter($event)"
    (showOwnershipsChange)="showOwnerships = $event">
  </app-large-shareholder-search-box>
  <app-generic-list
    [items]="largeShareholders"
    [columnDefinitions]="columnDefinitions"
    [pageSize]="pageSize"
    [currentPage]="currentPage - 1"
    [pageSizeOptions]="[5, 10, 25, 50]"
    [totalItems]="totalItems"
    [serverSidePagination]="true"
    [enableMatching]="true"
    [enableEdit]="true"
    [enableLink]="true"
    linkTooltip="Open in new tab"
    [enableDelete]="true"
    (sortChange)="onSortChange($event)"
    (pageChange)="onPageChange($event)"
    (editClick)="onEditLargeShareholder($event)"
    (linkClick)="onOpenLargeShareholderInNewTab($event)"
    (readyToMatch)="onReadyToMatch($event)"
    (deleteClick)="onDeleteLargeShareholder($event)"
    (listItemClick)="onListItemClick($event)">
  </app-generic-list>
</div>
